export const convertToCsv = csvData =>
  csvData
    .map(row =>
      row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','),
    )
    .join('\n');

export const shareCsvFile = async (csvData, fileName) => {
  const csvString = convertToCsv(csvData);
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const file = new File([blob], fileName, { type: 'text/csv' });

  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    await navigator.share({
      title: 'CSV Export',
      text: 'Sharing exported CSV',
      files: [file],
    });
  }
  return true;
};
